import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export function formatNumber(num) {
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1) + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(1) + 'K';
    }
    return num.toString();
}

export function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
}

export function calculateAccuracy(correct, total) {
    if (total === 0) return 0;
    return Math.round((correct / total) * 100);
}

export function getXPForLevel(level) {
    return level * 500;
}

export function getLevelFromXP(xp) {
    return Math.floor(xp / 500) + 1;
}

export function getSubjectColor(subject) {
    const colors = {
        "Business Associations": "from-violet-500 to-purple-600",
        "Civil Procedure": "from-blue-500 to-cyan-600",
        "Contracts": "from-emerald-500 to-green-600",
        "Constitutional Law": "from-red-500 to-orange-600",
        "Criminal Law and Procedure": "from-slate-500 to-gray-600",
        "Evidence": "from-amber-500 to-yellow-600",
        "Property": "from-teal-500 to-cyan-600",
        "Torts": "from-pink-500 to-rose-600",
    };
    return colors[subject] || "from-violet-500 to-purple-600";
}

export function getSubjectIcon(subject) {
    const icons = {
        "Business Associations": "Briefcase",
        "Civil Procedure": "Scale",
        "Contracts": "FileText",
        "Constitutional Law": "Landmark",
        "Criminal Law and Procedure": "Gavel",
        "Evidence": "Search",
        "Property": "Home",
        "Torts": "AlertTriangle",
    };
    return icons[subject] || "Book";
}
